import PDMPlp from "@tw/product-discovery-merchandizing-cra/lib/plp/category/category-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PDMPlp.domainName = "product-discovery";
PDMPlp.pageId = "PLP";

export default PageWrapper(PDMPlp);
